<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('help.title')" prop="title">
                <a-input v-model="queryParam.title" :placeholder="$t('help.inputTitle')" allow-clear />
              </a-form-item>
            </a-col>
            <template v-if="advanced">

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()">
          <a-icon type="plus" />{{ $t('common.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)">
          <a-icon type="edit" />{{ $t('common.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" >
          <a-icon type="delete" />{{ $t('common.delete') }}
        </a-button>
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['help:help:export']">-->
        <!--          <a-icon type="download" />导出-->
        <!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 2000 }"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"  />
          <a @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />{{ $t('common.edit') }}
          </a>
          <a-divider type="vertical"  />
          <a @click="handleDelete(record)">
            <a-icon type="delete" />{{ $t('common.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        :rowKey="(record, index) => index + 1"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageHelp,listHelp, delHelp } from '@/api/help/help'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Help',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用?
      single: true,
      // 非多个禁用?
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        sort: null,
        content: null,
        title: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('table.id'),
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: this.$t('help.titleIn'),
          dataIndex: 'titleIn',
          align: 'center'
        },
        {
          title: this.$t('help.titleEn'),
          dataIndex: 'titleEn',
          align: 'center'
        },
        {
          title: this.$t('help.titleCn'),
          dataIndex: 'titleCn',
          align: 'center'
        },
        {
          title: this.$t('help.title'),
          dataIndex: 'title',
          align: 'center'
        },
        {
          title: this.$t('help.contentIn'),
          dataIndex: 'contentIn',
          align: 'center'
        },
        {
          title: this.$t('help.contentEn'),
          dataIndex: 'contentEn',
          align: 'center'
        },
        {
          title: this.$t('help.contentCn'),
          dataIndex: 'contentCn',
          align: 'center'
        },
        {
          title: this.$t('help.content'),
          dataIndex: 'content',
          align: 'center'
        },
        {
          title: this.$t('help.sort'),
          dataIndex: 'sort',
          align: 'center'
        },
        {
          title: this.$t('help.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: '30%',
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          width: 150,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  watch: {
  },
  methods: {
    /** 查询帮助中心列表 */
    getList () {
      this.loading = true
     pageHelp(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        sort: undefined,
        content: undefined,
        title: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('system.confirmDelete'),
        content: this.$t('system.confirmDeleteContent') + ids,
        onOk() {
          return delHelp(ids)
            .then(() => {
              that.getList()
              that.$message.success(
                that.$t('system.deleteSuccess'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          // that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('system.confirmExport'),
        content: this.$t('system.confirmExportContent'),
        onOk () {
          that.download('help/help/export', {
            ...that.queryParam
          }, `${that.$t('help.exportFileName')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style scoped lang="less">
</style>
